import React from 'react';
import { XCircleIcon } from 'lucide-react';
const problems = ['Passi ore ogni settimana a pianificare le lezioni di Pilates da zero.', 'Finisci le idee e ripeti sempre gli stessi esercizi sul Mat o sul Reformer.', 'Non sai come gestire gruppi con livelli misti nello stesso momento.', 'Ti senti insicura di fronte a lesioni o allieve in gravidanza.', 'Arrivi in studio senza un piano d’azione e finisci per improvvisare.'];
export function ProblemSection() {
  return <section className="bg-[#0A0A0A] px-5 py-16" data-id="element-183" data-mp="35gkj141y4kbe">
      <div className="mx-auto max-w-4xl text-center" data-id="element-184" data-mp="35fr8drzv9anz">
        <p className="text-xs font-bold uppercase tracking-[.2em] text-emerald-300" data-id="element-185" data-mp="3jftqnfc3663r">
          La realtà dell'insegnamento
        </p>
        <h2 className="mt-3 font-display text-4xl font-bold uppercase leading-none text-white sm:text-5xl" data-id="element-186" data-mp="3eia8438cv760">
          Insegni Pilates? Questi problemi ti suonano familiari?
        </h2>
        <div className="mt-10 grid gap-3 text-left sm:grid-cols-2" data-id="element-187" data-mp="1k3zlm1f8gp3e">
          {problems.map(problem => <div key={problem} className="flex gap-3 border border-white/10 bg-[#16161F] p-4" data-id="element-188" data-mp="jeepei9tj9fw">
              <XCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-rose-400" data-id="element-189" data-mp="o9u2h80051b9" />
              <p className="text-sm font-semibold leading-snug text-white" data-id="element-190" data-mp="scic3hwjic9a">
                {problem}
              </p>
            </div>)}
        </div>
        <p className="mt-10 font-display text-3xl font-bold uppercase leading-none text-emerald-300 sm:text-4xl" data-id="element-191" data-mp="124e9srups0cz">
          Per quanto ancora vuoi continuare a improvvisare il tuo Pilates?
        </p>
      </div>
    </section>;
}